import * as React from 'react';

interface IContentProps {
  /** Additional class */
  className?: string;
  children: React.ReactNode;
}

/**
 * A Widget can have one child Content component and it should contain all of the general information for that Widget.
 */

export const Content = (props: IContentProps) => {
  const contentStyle = props.className
    ? `widget-content ${props.className}`
    : 'widget-content';
  return <div className={contentStyle}>{props.children}</div>;
};
export default Content;
